// from https://raw.githubusercontent.com/open-sdg/sdg-translations/2.0.0-dev/translations/en/global_goals.yml
import { SdgId } from '@upright/common/model/output/scores/sdg-alignment/types';

const sdgGoals: { [key: string]: string } = {
  '1-short': 'No poverty',
  '1-title': 'End poverty in all its forms everywhere',
  '10-short': 'Reduced inequalities',
  '10-title': 'Reduce inequality within and among countries',
  '11-short': 'Sustainable cities & communities',
  '11-title': 'Make cities and human settlements inclusive, safe, resilient and sustainable',
  '12-short': 'Responsible consumption and production',
  '12-title': 'Ensure sustainable consumption and production patterns',
  '13-short': 'Climate action',
  '13-title': 'Take urgent action to combat climate change and its impacts',
  '14-short': 'Life below water',
  '14-title': 'Conserve and sustainably use the oceans, seas and marine resources for sustainable\ndevelopment',
  '15-short': 'Life on land',
  '15-title':
    'Protect, restore and promote sustainable use of terrestrial ecosystems,\nsustainably manage forests, combat desertification, and halt and reverse land degradation\nand halt biodiversity loss',
  '16-short': 'Peace and justice - strong institutions',
  '16-title':
    'Promote peaceful and inclusive societies for sustainable development, provide\naccess to justice for all and build effective, accountable and inclusive institutions\nat all levels',
  '17-short': 'Partnerships for the goals',
  '17-title':
    'Strengthen the means of implementation and revitalize the Global Partnership\nfor Sustainable Development',
  '2-short': 'Zero hunger',
  '2-title': 'End hunger, achieve food security and improved nutrition and promote sustainable\nagriculture',
  '3-short': 'Good health and well-being',
  '3-title': 'Ensure healthy lives and promote well-being for all at all ages',
  '4-short': 'Quality education',
  '4-title': 'Ensure inclusive and equitable quality education and promote lifelong learning\nopportunities for all',
  '5-short': 'Gender equality',
  '5-title': 'Achieve gender equality and empower all women and girls',
  '6-short': 'Clean water and sanitation',
  '6-title': 'Ensure availability and sustainable management of water and sanitation for\nall',
  '7-short': 'Affordable and clean energy',
  '7-title': 'Ensure access to affordable, reliable, sustainable and modern energy for\nall',
  '8-short': 'Decent jobs and economic growth',
  '8-title':
    'Promote sustained, inclusive and sustainable economic growth, full and productive\nemployment and decent work for all',
  '9-short': 'Industry, innovation and infrastructure',
  '9-title':
    'Build resilient infrastructure, promote inclusive and sustainable industrialization\nand foster innovation',
};

export function getSdgGoalShortTitle(id: SdgId): string | undefined {
  const key = `${id}-short`;
  return sdgGoals[key] || 'SDG {id}';
}

export function getSdgGoalLongTitle(id: SdgId): string | undefined {
  const key = `${id}-title`;
  return sdgGoals[key] || 'SDG {id}';
}
